import { useState } from 'react';
import apiService from '../services/api';

const useConsultationsCrud = () => {
  const [isLoading, setIsLoading] = useState(false);

  const addConsultation = async (consultationData) => {
    setIsLoading(true);
    try {
      const response = await apiService.createConsultation(consultationData);
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de l\'ajout de la consultation:', error);
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const updateConsultation = async (id, consultationData) => {
    setIsLoading(true);
    try {
      const response = await apiService.updateConsultation(id, consultationData);
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la modification de la consultation:', error);
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const deleteConsultation = async (id) => {
    setIsLoading(true);
    try {
      const response = await apiService.deleteConsultation(id);
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la suppression de la consultation:', error);
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addConsultation,
    updateConsultation,
    deleteConsultation,
    isLoading
  };
};

export { useConsultationsCrud };
export default useConsultationsCrud;
